import {
    GET_CLAIM_PAYMENT_FILTERED_SUCCESS,
    GET_CLAIM_PAYMENTS_SUCCESS,
    GET_REMITTANCE_BY_ID_CLAIMS_SUCCESS,
    GET_REMITTANCE_BY_ID_SUCCESS,
    GET_REMITTANCE_SUCCESS,
    GET_REMITTANCE_TOTAL_SUCCESS,
} from './claimPayment.type';

const initialState = {
    claimPayments: [],
    remittances: [],
    remittanceById: null,
    remittanceByIdClaims: [],
    remittanceTotal: null,

    claimPaymentsFiltered: [],
};

export const claimPaymentReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CLAIM_PAYMENTS_SUCCESS:
            return {
                ...state,
                claimPayments: action.payload.claimPayments,
            };

        case GET_CLAIM_PAYMENT_FILTERED_SUCCESS:
            return {
                ...state,
                claimPaymentsFiltered: action.payload,
            };

        case GET_REMITTANCE_SUCCESS:
            return {
                ...state,
                remittances: action.payload,
            };

        case GET_REMITTANCE_BY_ID_SUCCESS:
            return {
                ...state,
                remittanceById: action.payload,
            };

        case GET_REMITTANCE_BY_ID_CLAIMS_SUCCESS:
            return {
                ...state,
                remittanceByIdClaims: action.payload,
            };

        case GET_REMITTANCE_TOTAL_SUCCESS:
            return {
                ...state,
                remittanceTotal: action.payload,
            };

        default:
            return state;
    }
};
